<template>
  <div class="page-inner r" style="min-height: 100vh;">
    <div class="page-title">
      <h3>{{ $t('message.Статистика') }}</h3>
      <div class="page-breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/">{{ $t('message.Главная') }}</router-link>
          </li>
          <li class="active breadcrumb-item">{{ $t('message.Статистика') }}</li>
        </ol>
      </div>
    </div>

    <div id="main-wrapper" v-if="hasStatisticsReadPermission">
      <b-card-group deck class="justify-content-center">
        <b-card
          style="max-width: 22rem;"
          border-variant="secondary"
          align="center"
          header-bg-variant="primary"
          header-text-variant="white"
          footer-bg-variant="white"
          footer-border-variant="0"
          header-tag="h3"
        >
          <template v-slot:header>
            {{ $t("message.Абоненты") }}
          </template>
          <template v-slot:footer>
            <b-link to="/accounts">
              {{ $t("message.К_списку_абонентов") }}
            </b-link>
          </template>
          <b-card-body>
            <div align="center">
            <table border=1>
              <tr><td></td><td>TEST</td><td>SUBS</td><td>TECH</td><td>TOTAL</td></tr>
              <tr>
                <td>Total:</td>           
                <td>{{ fields.accountTotal_Test }}</td>
                <td>{{ fields.accountTotal_Subs }}</td>
                <td>{{ fields.accountTotal_Tech }}</td>
                <td>{{ fields.accountTotal }}</td>
              </tr>
              <tr>
                <td>Active:</td>          
                <td>{{ fields.accountTotalActive_Test }}</td>
                <td>{{ fields.accountTotalActive_Subs }}</td>
                <td>{{ fields.accountTotalActive_Tech }}</td>
                <td>{{ fields.accountTotalActive }}</td>
              </tr>
              <tr>
                <td nowrap>In use:</td>          
                <td>{{ fields.accountTotalInUse_Test }}</td>
                <td>{{ fields.accountTotalInUse_Subs }}</td>
                <td>{{ fields.accountTotalInUse_Tech }}</td>
                <td>{{ fields.accountTotalInUse }}</td>
              </tr>
              <tr>
                <td nowrap>In Use Last Week:</td>
                <td>{{ fields.accountTotalInUseLW_Test }}</td>
                <td>{{ fields.accountTotalInUseLW_Subs }}</td>
                <td>{{ fields.accountTotalInUseLW_Tech }}</td>
                <td>{{ fields.accountTotalInUseLW }}</td>
              </tr>
              <tr>
                <td nowrap>Megogo active:</td>   
                <td>{{ fields.megogoActive_Test }}</td>
                <td>{{ fields.megogoActive_Subs }}</td>
                <td>{{ fields.megogoActive_Tech }}</td>
                <td>{{ fields.megogoActive }}</td>
              </tr>
            </table>
            </div>
            <!-- <p class="card-text">Total:             {{ fields.accountTotal }}</p>
            <p class="card-text">Active:            {{ fields.accountTotalActive }}</p>
            <p class="card-text">In use:            {{ fields.accountTotalInUse }}</p>
            <p class="card-text">In Use Last Week:  {{ fields.accountTotalInUseLW }}</p>            
            <p class="card-text">Megogo active:     {{ fields.megogoActive }}</p>             -->
          </b-card-body>
        </b-card>
        <b-card
        style="max-width: 16rem;"
          border-variant="secondary"
          align="center"
          header-bg-variant="primary"
          header-text-variant="white"
          footer-bg-variant="white"
          footer-border-variant="0"
          header-tag="h3"
        >
          <template v-slot:header>
            {{ $t("message.Пакеты") }}
          </template>
          <template v-slot:footer>
            <b-link to="/packages">
              {{ $t("message.К_списку_пакетов") }}
            </b-link>
          </template>
          <b-card-body>
            <p class="card-text">Total: {{ fields.packageTotal }}</p>
          </b-card-body>
        </b-card>
        <b-card
        style="max-width: 16rem;"
          border-variant="secondary"
          align="center"
          header-bg-variant="primary"
          header-text-variant="white"
          footer-bg-variant="white"
          footer-border-variant="0"
          header-tag="h3"
        >
          <template v-slot:header>
            {{ $t("message.Каналы") }}
          </template>
          <template v-slot:footer>
            <b-link to="/channels">
              {{ $t("message.К_списку_каналов") }}
            </b-link>
          </template>
          <b-card-body>
            <p class="card-text">Total: {{ fields.channelTotal }}</p>
            <p class="card-text">Active: {{ fields.channelTotalActive }}</p>
          </b-card-body>
        </b-card>
      </b-card-group>
      <b-card-group deck class="mt-3 justify-content-center">
        <b-card
        style="max-width: 16rem;"
          border-variant="secondary"
          align="center"
          header-bg-variant="primary"
          header-text-variant="white"
          footer-bg-variant="white"
          footer-border-variant="0"
          header-tag="h3"
        >
          <template v-slot:header>
            {{ $t("message.Сервисы") }}
          </template>
          <template v-slot:footer>
            <b-link to="/services">
              {{ $t("message.К_списку_сервисов") }}
            </b-link>
          </template>
          <b-card-body>
            <p class="card-text">Total: {{ fields.serviceTotal }}</p>
          </b-card-body>
        </b-card>
        <b-card
        style="max-width: 16rem;"
          border-variant="secondary"
          align="center"
          header-bg-variant="primary"
          header-text-variant="white"
          footer-bg-variant="white"
          footer-border-variant="0"
          header-tag="h3"
        >
          <template v-slot:header>
            {{ $t("message.Категории") }}
          </template>
          <template v-slot:footer>
            <b-link to="/categories">
              {{ $t("message.К_списку_категорий") }}
            </b-link>
          </template>
          <b-card-body>
            <p class="card-text">Total: {{ fields.categoryTotal }}</p>
          </b-card-body>
        </b-card>
        <b-card
        style="max-width: 16rem;"
          border-variant="secondary"
          align="center"
          header-bg-variant="primary"
          header-text-variant="white"
          footer-bg-variant="white"
          footer-border-variant="0"
          header-tag="h3"
        >
          <template v-slot:header>
            {{ $t("message.Колокейшены") }}
          </template>
          <template v-slot:footer>
            <b-link to="/colocations">
              {{ $t("message.К_списку_колокейшинов") }}
            </b-link>
          </template>
          <b-card-body>
            <p class="card-text">Total: {{ fields.colocationTotal }}</p>
          </b-card-body>
        </b-card>
      </b-card-group>

      <b-card-group deck class="mt-3 justify-content-center">
        <b-card
        style="max-width: 16rem;"
          border-variant="secondary"
          align="center"
          header-bg-variant="primary"
          header-text-variant="white"
          footer-bg-variant="white"
          footer-border-variant="0"
          header-tag="h3"
        >
          <template v-slot:header>
            {{ $t("message.Видеотека") }}
          </template>
          <template v-slot:footer>
            <b-link to="/vod_movies">
              {{ $t("message.К_списку_фильмов") }}
            </b-link>
          </template>
          <b-card-body>
            <p class="card-text">Movies: {{ fields.vodMovieTotal }}</p>
            <p class="card-text">Genres: {{ fields.vodGenreTotal }}</p>
            <p class="card-text">Packages: {{ fields.vodPackageTotal }}</p>
            <p class="card-text">Streams: {{ fields.vodStreamTotal }}</p>
            <p class="card-text">Services: {{ fields.vodServiceTotal }}</p>
          </b-card-body>
        </b-card>
      </b-card-group>      
    </div>

  </div>
</template>

<script>
export default {
  name: "StatisticsCount",
  data() {
    return {
        fields: {}
    };
  },
  computed: {
    hasStatisticsReadPermission: function() {
      return !!this.$storage
        .get("current_user")
        .permissions.filter(value => value == "statistics:read").length;
    }
  },
  created: function() {
    let promise = this.$noname.get('statistics_count');

    promise.then((data) => {
      this.fields = data.data
    }).catch(this.$noname.HandleError)
  }
};
</script>



// WEBPACK FOOTER //
// src/components/modules/Statistics.vue